<template>
  <div class="feeds">
    <ul :class="`feeds-list ${openList}`">
      <router-link
        v-for="(feed, index) in feeds"
        tag="li"
        @click.native="handleSwitch"
        :to="{
          name: getPage(),
          params: { threadName: feed.threadname, id: feed.id }
        }"
        :key="feed.id"
        active-class="feeds-list__item--current"
        :class="getThreadClass(feed, index)"
      >
        {{ feed.threadname }}
        <button
          class="feeds-list__collapse"
          @click="toggleList($event)"
          v-if="$route.params.id === feed.id"
        >
          <i class="material-icons md-24 color_light" v-if="isOpenList">
            arrow_drop_up
          </i>
          <i class="material-icons md-24 color_light" v-else>
            arrow_drop_down
          </i>
        </button>
      </router-link>
    </ul>
  </div>
</template>

<script>
// store
import { SET_THREAD_NAME } from "../../../../store/actions/threadInfo";

// helpers
import { findIndexById } from "../../../../helpers/arrayHelper.js";

// vuex
import { mapGetters } from "vuex";

export default {
  name: "FeedsList",
  props: {
    translationPlay: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      feeds: [],
      isOpenList: false,
      openListClass: "feeds--open",
      page: "threadId",
      model: {
        items: [],
        active: 0,
        next: 0
      },
      threadPlayTimeout: ""
    };
  },
  computed: {
    ...mapGetters(["innerPage", "feedsList"]),
    openList: function() {
      return this.isOpenList ? this.openListClass : "";
    },
    activeIndex() {
      return findIndexById(this.feeds, this.$route.params.id);
    }
  },
  methods: {
    handleSwitch() {

      if (this.translationPlay) {
        clearInterval(this.threadPlayTimeout);
        this.setInterval();
      } else {
        this.shakeFeeds();
      }

      let elem = document.querySelector("#top");
      elem.scrollTop = 0;

      this.isOpenList = !this.isOpenList;
    },
    getPage() {
      return this.innerPage ? this.innerPage : this.page;
    },
    shakeFeeds() {
      const readFeeds = this.feeds.slice(0, this.activeIndex);
      this.feeds.splice(0, this.activeIndex);
      this.feeds = [...this.feeds, ...readFeeds];
    },
    setModelNext() {
      const next = this.model.active + 1;
      this.model.next = this.model.items[next] ? next : 0;
    },
    getThreadClass(feed) {
      let threadClass = "feeds-list__item";

      if (feed.featured) {
        threadClass = `${threadClass} feeds-list__item--warning`;
      }

      return threadClass;
    },
    toggleList(event) {
      event.stopPropagation();
      this.isOpenList = !this.isOpenList;
    },
    setThreads() {
      this.feeds = JSON.parse(JSON.stringify(this.feedsList));
      this.fillModel();
      this.setModelActive();
      this.setModelNext();
    },
    fillModel() {
      this.feeds.forEach(item => {
        this.model.items.push({
          id: item.id,
          threadName: item.threadname
        });
      });
    },
    goToNextPage() {
      const params = {
        threadName: this.model.items[this.model.next].threadName,
        id: this.model.items[this.model.next].id
      };

      this.$router.push({
        name: this.getPage(),
        params
      });

      let elem = document.querySelector("#top");
      elem.scrollTop = 0;
    },
    setModelActive() {
      this.model.active = findIndexById(
        this.model.items,
        this.$route.params.id
      );
    },
    setInterval() {
      this.threadPlayTimeout = setInterval(() => {
        this.threadsAnimation();
      }, 300000);
    },
    threadsAnimation() {
      setTimeout(() => {
        const promise = new Promise(resolve => {
          const readFeeds = this.feeds.slice(0, this.activeIndex + 1);
          this.feeds.splice(0, this.activeIndex + 1);
          this.feeds = [...this.feeds, ...readFeeds];
          resolve();
        });
        promise
          .then(() => {
            this.goToNextPage();
          });
        promise.catch((err) => {
          console.log(err);
        });
      }, 400);
    }
  },
  updated() {
    this.$nextTick(() => {
      if (!this.$route.params.id) {
        const params = {
          threadName: this.feeds[0].threadname,
          id: this.feeds[0].id
        };
        this.$router.push({
          name: this.getPage(),
          params
        });
      }
    });
  },
  mounted() {
    this.setThreads();
  },
  watch: {
    $route(val) {
      if (val.params.threadName) {
        this.setModelActive();
        this.setModelNext();
        this.$store.dispatch(SET_THREAD_NAME, this.$route.params.threadName);
      }
    },
    translationPlay(val) {
      if (val) {
        this.setInterval();
      } else {
        clearInterval(this.threadPlayTimeout);
      }
    }
  }
};
</script>

<style>
.feeds {
  position: absolute;
  z-index: 2;
  width: 100%;
  border-left: 1px solid #c4c4c4;
  border-right: 1px solid #c4c4c4;
  border-bottom: 1px solid #c4c4c4;
  box-sizing: border-box;
  background-color: #ffffff;
}

.feeds-list {
  padding: 0;
  margin: 0;
  font-family: "Oswald", "Arial", sans-serif;
  font-weight: 300;
  font-size: 16px;
  line-height: normal;
  list-style: none;
}

.feeds-list__item {
  display: none;
  padding: 7px 0 9px 9px;
  margin: 7px 10px;
  background-color: #f5f5f5;
  color: #000000;
  cursor: pointer;
  transition: background-color, color;
  transition-duration: 0.4s, 0.4s;
}

.feeds-list__item:last-child {
  margin-bottom: 0;
}

.feeds-list__item--warning {
  background-color: #ffd600;
}

.feeds-list__item--current {
  display: block;
  position: relative;
  padding: 7px 0 9px 12px;
  margin: 0;
  background-color: #0084ff;
  color: #ffffff;
  box-sizing: border-box;
}

.feeds-list__item:hover {
  background-color: #0084ff;
  color: #ffffff;
}

.feeds--open {
  padding-bottom: 10px;
}

.feeds--open .feeds-list__item {
  display: block;
}

.feeds-list__collapse {
  position: absolute;
  top: 0;
  right: 0;
  padding: 0;
  margin: 0;
  height: 100%;
  width: 40px;
  border-left: 1px solid #7ec1ff;
  border-right: none;
  border-bottom: none;
  border-top: none;
  background: none;
  cursor: pointer;
  outline: none;
}

@media (max-width: 1040px) {
  .feeds {
    display: none;
  }
}
</style>
